// extracted by mini-css-extract-plugin
export default {"container":"transactions_container__e2QPe","chargebackFlag":"transactions_chargebackFlag__9o6SF"};